import {EventCustomAction, EventCustomLabel, EventCustomParameters} from '_types'
import {analyticsEventCustom} from './event-custom'

interface Parameters {
    action: EventCustomAction
    label: EventCustomLabel
}

/**
 * Tracks an exclusive service item click event triggered by the user.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {EventCustomAction} params.action - Action of the event.
 * @param {EventCustomLabel} params.label - Label of the event.
 */
export function analyticsEventExclusiveServicesAppointmentClick({action, label}: Parameters) {
    const eventDetails: EventCustomParameters = {
        category: 'exclusive-service-appointment',
        action: action,
        label: label,
    }

    analyticsEventCustom(eventDetails)
}
